import * as z from 'zod'
import { schemaBoolish } from './zodUtils.js'

export const feePutSchema = z.object({
    id: z.string().optional(),
    feeCash: z.coerce.string().nullish(),
    feeUnits: z.coerce.string().nullish(),
    feeBoth: schemaBoolish.nullish(),
    feeLevel: z.coerce.number().nullish(),
    topDown: schemaBoolish.nullish(),
    middleDown: z.coerce.string().nullish(),
})

export const advisorSchema = z.object({
    id: z.string().optional(),
    name: z.string(),
    type: z.string(),
})

export const linkedIssueSchema = z.object({
    groupId: z.string(),
    convertibles: z.array(z.object({ id: z.string() })),
    issues: z.array(z.object({ id: z.string() })),
})
